// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"550":"53f6776c","728":"b2ea5594"}[chunkId] + ".chunk.css";
};